export default __webpack_public_path__ + "static/media/bonus1.66a3a255.svg";